import axios from "axios";
import { PROFILE_INFORMATION_URL } from "../utils";

export const fetchProfileInformation = async () => {
  return await axios.get(PROFILE_INFORMATION_URL);
};
